import { TypedDocumentNode, gql } from "@apollo/client";
import { UniversitiesQuery, UniversityEnrollmentsQuery, UniversityEnrollmentsQueryVariables } from "./types";

export const UNIVERSITIES_QUERY: TypedDocumentNode<UniversitiesQuery> = gql`
  query universities {
    universities {
      id
      legacyId
      name
      logoUrl
      activeStudentCount
      alumniStudentCount
      studentProgramSummary {
        activeLevel0
        activeLevel1
        activeLevel2
        activeLevel3
        completions
        programVersion
      }
      address {
        address1
        address2
        algoliaId
        city
        id
        name
        state
        zip
      }
    }
  }
`;

export const UNIVERSITY_ENROLLMENTS_QUERY: TypedDocumentNode<
  UniversityEnrollmentsQuery,
  UniversityEnrollmentsQueryVariables
> = gql`
  query universityEnrollments($id: ID!) {
    university(id: $id) {
      id
      studentProgramSummary {
        activeLevel0
        activeLevel1
        activeLevel2
        activeLevel3
        completions
        programVersion
      }
    }
  }
`;
